export class UnifiedDBRecord {
    'type';
    'table';
    'schema';
    'db';
    'server';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "type",
            "baseName": "type",
            "type": "string",
            "format": ""
        },
        {
            "name": "table",
            "baseName": "table",
            "type": "UnifiedTableRecord",
            "format": ""
        },
        {
            "name": "schema",
            "baseName": "schema",
            "type": "UnifiedSchemaRecord",
            "format": ""
        },
        {
            "name": "db",
            "baseName": "db",
            "type": "UnifiedDatabaseRecord",
            "format": ""
        },
        {
            "name": "server",
            "baseName": "server",
            "type": "UnifiedDBServerRecord",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return UnifiedDBRecord.attributeTypeMap;
    }
    constructor() {
    }
}
